import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import Button from '../../components/Button'
import Textarea from '../../components/Textarea'
import { useNavigate, useParams } from 'react-router-dom'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGE } from '../../utils/constants'
import { useApiProgress } from '../../hooks/ApiProgress'
import { Fragment, useEffect, useState } from 'react'
import { Transition, Dialog } from '@headlessui/react'
import { FaPlus } from "react-icons/fa";
import { OUTSOURCER_PATH, getOutsourcerById, getPageOutsourcers } from '../../api/outsourcerApi'
import useFirstRender from '../../hooks/FirstRender'
import { OPERATION_PATH, getPageOperations } from '../../api/operationApi'
import { PRODUCT_PATH, getPageProducts } from '../../api/productApi'
import { FaMinus } from "react-icons/fa6";
import { getProductionRecordById, updateProductionRecord } from '../../api/productionRecordApi'
import { addProductionPlan, completeProductionPlanById, deleteProductionPlan, getAllProductionPlans, sendProductionPlanById, takeBackProductionPlanById, updateProductionPlan } from '../../api/productionPlanApi'

import PlanCard from '../../components/production-record/PlanCard'
import OutsourcerPicker from '../../components/outsourcer/OutsourcerPicker'
import OperationPicker from '../../components/operation/OperationPicker'
import ProductPicker from '../../components/product/ProductPicker'
import ProductLabel from '../../components/product/ProductLabel'


const ProductionRecordEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams()
    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const closeTab = useCloseTab()

    const [productionRecord, setProductionRecord] = useState({
        outsourcer: undefined,
        productionDate: "",
        vat: "",
        invoiceNumberOut: "",
        invoiceNumberIn: "",
    })

    const [outsourcerPage, setOutsourcerPage] = useState({
        content: []
    });

    const [operationPage, setOperationPage] = useState({
        content: []
    })

    const [productPage, setProductPage] = useState({
        content: []
    });

    const [plan, setPlan] = useState({
        operation: undefined,
        inputDetails: [],
        outputDetail: undefined
    })

    const [outsourcerQuery, setOutsourcerQuery] = useState('')
    const [searchTimerOutsourcer, setSearchTimerOutsourcer] = useState();
    const pendingApiCallOutsourcer = useApiProgress('get', `${OUTSOURCER_PATH}/page`, false)
    const [errors, setErrors] = useState({})
    const [isOpenPlanModal, setIsOpenPlanModal] = useState(false)

    const [plans, setPlans] = useState([])

    const pendingApiCallOperation = useApiProgress('get', `${OPERATION_PATH}/page`, false)
    const pendingApiCallProduct = useApiProgress('get', `${PRODUCT_PATH}/page`, false)

    const [operationQuery, setOperationQuery] = useState('')
    const [productQuery, setProductQuery] = useState('')

    const [searchTimerOperation, setSearchTimerOperation] = useState();
    const [searchTimerProduct, setSearchTimerProduct] = useState();

    const searchingOperation = async (params) => {
        if (searchTimerOperation) clearTimeout(searchTimerOperation);
        let timer = setTimeout(() => {
            getPageOperations(params)
                .then(res => {
                    setOperationPage(res.data)
                })
        }, 500);
        setSearchTimerOperation(timer);
    }


    const searchingProduct = async (params) => {
        if (searchTimerProduct) clearTimeout(searchTimerProduct);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimerProduct(timer);
    }

    const searchingOutsourcer = async (params) => {
        if (searchTimerOutsourcer) clearTimeout(searchTimerOutsourcer);
        let timer = setTimeout(() => {
            getPageOutsourcers(params)
                .then(res => {
                    setOutsourcerPage(res.data)
                })
        }, 500);
        setSearchTimerOutsourcer(timer);
    }

    useEffect(() => {
        if (!isOpenPlanModal) {
            setPlan({ inputDetails: [] })
            setInputDetail({})
            setOutputDetail({})
        }

    }, [isOpenPlanModal])

    const onClickLoadMoreProduct = () => {
        if (!productPage.last) {
            loadProducts({ search: productQuery, lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }

    const loadProducts = (params) => {
        !pendingApiCallProduct &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const onClickLoadMoreOperation = () => {
        if (!operationPage.last) {
            loadOperations({ search: operationQuery, lastId: operationPage.content[operationPage.content.length - 1]?.id })
        }
    }



    const loadOperations = (params) => {
        !pendingApiCallOperation &&
            getPageOperations(params)
                .then(res => {
                    setOperationPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const loadOutsourcers = (params) => {
        !pendingApiCallOutsourcer &&
            getPageOutsourcers(params)
                .then(res => {
                    setOutsourcerPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    useEffect(() => {
        !isFirstRender && searchingOutsourcer({ search: outsourcerQuery })
    }, [outsourcerQuery])

    useEffect(() => {
        !isFirstRender && searchingOperation({ search: operationQuery })
    }, [operationQuery])

    useEffect(() => {
        !isFirstRender && searchingProduct({ search: productQuery })
    }, [productQuery])

    const [inputDetail, setInputDetail] = useState({
        product: null,
        quantity: ""
    })

    const [outputDetail, setOutputDetail] = useState({
        product: null,
        quantity: ""
    })

    useEffect(() => {
        getProductionRecordById(id)
            .then(res => {
                setProductionRecord(res.data)
                getOutsourcerById(res.data.outsourcerId)
                    .then(res => {
                        setProductionRecord(prevState => ({ ...prevState, outsourcer: res.data }))
                    })
            })
        getAllProductionPlans({ recordId: id })
            .then(res => {
                setPlans(res.data)
            })
    }, [id])

    const onClickLoadMoreOutsourcer = () => {
        if (!outsourcerPage.last) {
            loadOutsourcers({ search: outsourcerQuery, lastId: outsourcerPage.content[outsourcerPage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        loadOutsourcers({ size: 20 })
        loadOperations({ size: 20 })
        loadProducts({ size: 20 })
    }, [])

    const onClickEditPlan = (plan) => {
        setIsOpenPlanModal(true)
        setPlan(plan)
        setOutputDetail(plan.outputDetail)
    }

    const onClickAddPlan = () => {
        const body = {
            operationId: plan.operation?.id,
            inputDetails: plan.inputDetails.map((inputDetail) => {
                return {
                    productId: inputDetail.product?.id,
                    quantity: inputDetail.quantity
                }
            }),
            outputDetail: {
                productId: plan.outputDetail.product?.id,
                quantity: plan.outputDetail.quantity
            },
            description: plan.description,
            productionRecordId: id
        }
        if (plan.id) {
            updateProductionPlan(plan.id, body)
                .then(res => {
                    setPlans(prevState => prevState.map(p => {
                        if (p.id === res.data.id) return res.data
                        else return p
                    }))
                    toast.success("Üretim planı güncellendi")
                    setIsOpenPlanModal(false)
                })
        } else {
            addProductionPlan(body)
                .then(res => {
                    setPlans(prevState => ([...prevState, res.data]))
                })
            setIsOpenPlanModal(false)
            toast.success("Üretim planı kaydedildi")
        }
    }

    const onClickAddInputDetail = () => {
        if (inputDetail.product && inputDetail.quantity) {
            setPlan(prevState => ({ ...prevState, inputDetails: [...prevState.inputDetails, inputDetail] }))
        } else {
            toast.error('Lütfen verileri girin')
        }
    }

    const onClickRemoveInputDetail = (index) => {
        setPlan(prevState => ({ ...prevState, inputDetails: prevState.inputDetails.filter((d, i) => i !== index) }))
    }

    const onClickRemoveOutputDetail = () => {
        setPlan(prevState => ({ ...prevState, outputDetail: undefined }))
    }

    const onClickAddOutputDetail = () => {
        setPlan(prevState => ({ ...prevState, outputDetail }))
    }

    const onClickDeletePlan = (id) => {
        deleteProductionPlan(id)
            .then(res => {
                setPlans(prevState => (prevState.filter(p => p.id !== id)))
                toast.success('Üretim kaydı silindi')
            })

    }

    const onClickSendPlan = (id) => {
        sendProductionPlanById(id)
            .then(res => {
                setPlans(prevState => prevState.map(p => {
                    if (p.id === res.data.id) return res.data
                    else return p
                }))
                toast.success('Üretim planı üretimde')
            }).catch(err => {

            })
    }

    const onClickTakeBackPlan = (id) => {
        takeBackProductionPlanById(id)
            .then(res => {
                setPlans(prevState => prevState.map(p => {
                    if (p.id === res.data.id) return res.data
                    else return p
                }))
                toast.success('Üretim planı geri alındı')
            }).catch(err => {

            })
    }

    const onClickCompletePlan = (id) => {
        completeProductionPlanById(id)
            .then(res => {
                setPlans(prevState => prevState.map(p => {
                    if (p.id === res.data.id) return res.data
                    else return p
                }))
                toast.success('Üretim planı tamamlandı')
            }).catch(err => {

            })
    }

    const onSubmit = () => {
        const body = {
            outsourcerId: productionRecord.outsourcer?.id,
            productionDate: productionRecord.productionDate,
            vat: productionRecord.vat,
            invoiceNumberOut: productionRecord.invoiceNumberOut,
            invoiceNumberIn: productionRecord.invoiceNumberIn
        }
        updateProductionRecord(id, body)
            .then(res => {
                toast.success("Üretim planı güncellendi")
                closeTab()
            }).catch(err => {
                setErrors(err.response.data.validationErrors)
                toast.error(VALIDATION_MESSAGE)
            })
    }

    return (
        <div>
            <div className='mb-5'>
                <label className='text-xl'>Üretim Düzenle</label>
            </div>
            <div className='grid grid-cols-12 gap-x-3 mb-10'>
                {/* OUTSOURCER PICKER */}
                <OutsourcerPicker
                    label='Fasoncu'
                    pendingApiCall={pendingApiCallOutsourcer}
                    state={productionRecord.outsourcer}
                    setState={(value) => setProductionRecord(prevState => ({ ...prevState, outsourcer: value }))}
                    query={outsourcerQuery}
                    setQuery={setOutsourcerQuery}
                    error={errors.outsourcerId}
                    page={outsourcerPage}
                    setErrors={() => setErrors(prevState => ({ ...prevState, outsourcerId: undefined }))}
                    onClickClear={() => setProductionRecord(prevState => ({ ...prevState, outsourcer: undefined }))}
                    onClickLoadMore={() => onClickLoadMoreOutsourcer()}
                    disabled={productionRecord.charged}
                />
                <div className='col-span-2'>
                    <Input
                        name='productionDate'
                        label='Üretim Tarihi'
                        type='date'
                        value={productionRecord.productionDate}
                        error={errors?.productionRecordDate}
                        onChange={e => onChange(e, setProductionRecord, setErrors)}
                        disabled={productionRecord.charged}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='vat'
                        label='Vergi Oranı (%)'
                        type='number'
                        placeholder='Vergi oranı...'
                        value={productionRecord.vat}
                        error={errors?.vat}
                        onChange={e => onChange(e, setProductionRecord, setErrors)}
                        disabled={productionRecord.charged}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='invoiceNumberOut'
                        label='Fatura numarası çıkış'
                        type='text'
                        placeholder='Fatura numarası çıkış...'
                        value={productionRecord.invoiceNumberOut}
                        error={errors?.invoiceNumberOut}
                        onChange={e => onChange(e, setProductionRecord, setErrors)}
                        disabled={productionRecord.charged}
                    />
                </div>
                <div className='col-span-2'>
                    <Input
                        name='invoiceNumberIn'
                        label='Fatura numarası giriş'
                        type='text'
                        placeholder='Fatura numarası giriş...'
                        value={productionRecord.invoiceNumberIn}
                        error={errors?.invoiceNumberIn}
                        onChange={e => onChange(e, setProductionRecord, setErrors)}
                        disabled={productionRecord.charged}
                    />
                </div>
            </div>
            <div className='mb-5'>
                <div className='flex gap-x-2 items-center'>
                    <label className='text-lg'>Üretim Planları</label>
                    {
                        !productionRecord.charged &&
                        <FaPlus className='cursor-pointer' onClick={() => setIsOpenPlanModal(true)} />
                    }
                </div>
                {/* PlANS */}
                <div className='grid grid-cols-3 gap-x-5 mb-10'>
                    {
                        plans.map((plan, index) => (
                            <PlanCard
                                key={index}
                                plan={plan}
                                onClickEdit={() => onClickEditPlan(plan)}
                                onClickShipment={() => nav(`/production-record/${id}/plan/${plan.id}/shipping`)}
                                onClickSend={() => onClickSendPlan(plan.id)}
                                onClickTakeBack={() => onClickTakeBackPlan(plan.id)}
                                onClickNavShipmentPage={() => nav(`/production-record/${id}/plan/${plan.id}/complete`)}
                                onClickComplete={() => onClickCompletePlan(plan.id)}
                                onClickTrash={() => onClickDeletePlan(plan.id)}
                                disabled={productionRecord.charged}
                            />
                        ))
                    }
                </div>
                {
                    !productionRecord.charged &&
                    <div>
                        <Button
                            text='Kaydet'
                            variant='green'
                            onClick={onSubmit}
                        />
                    </div>
                }

            </div>

            <Transition appear show={isOpenPlanModal} as={Fragment}>
                <Dialog as="div" onClose={() => setIsOpenPlanModal(false)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-xl transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900 mb-5"
                                    >
                                        Yeni Plan
                                    </Dialog.Title>

                                    {/* OPERATION PICKER */}
                                    <OperationPicker
                                        label='İşlem'
                                        pendingApiCall={pendingApiCallOperation}
                                        state={plan.operation}
                                        setState={(value) => setPlan(prevState => ({ ...prevState, operation: value }))}
                                        query={operationQuery}
                                        setQuery={setOperationQuery}
                                        error={errors.operationId}
                                        page={operationPage}
                                        setErrors={prevState => ({ ...prevState, outsourcerId: undefined })}
                                        onClickClear={() => setPlan(prevState => ({ ...prevState, operation: undefined }))}
                                        onClickLoadMore={() => onClickLoadMoreOperation()}
                                    />
                                    {/* INPUT_DETAILS */}
                                    <div className='p-2 border shadow-md rounded-md mb-10'>
                                        <label className='mb-3 block'>Gidecek Ürünler</label>
                                        <div className='mb-5 border-b'>
                                            {
                                                plan.inputDetails?.map((inputDetail, index) => (
                                                    <div key={index} className='mb-2 grid grid-cols-12 gap-x-2 bg-purple-100 p-2 rounded-md'>
                                                        <div className='col-span-1'>
                                                            {index + 1}.
                                                        </div>
                                                        <div className='col-span-8'>
                                                            <ProductLabel state={inputDetail.product} />
                                                        </div>
                                                        <div className='col-span-2 text-center text-sm'>
                                                            {inputDetail.quantity} m
                                                        </div>
                                                        <div className='col-span-1 flex justify-center self-center'>
                                                            <FaMinus className='cursor-pointer' onClick={() => onClickRemoveInputDetail(index)} />
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        {/* INPUT_DETAIL PRODUCT PICKER */}
                                        <div className='grid grid-cols-12 gap-x-2 items-center'>
                                            <div className='col-span-8'>
                                                <ProductPicker
                                                    label='Ürün'
                                                    pendingApiCall={pendingApiCallProduct}
                                                    state={inputDetail.product}
                                                    setState={(value) => setInputDetail(prevState => ({ ...prevState, product: value }))}
                                                    query={productQuery}
                                                    setQuery={setProductQuery}
                                                    error={errors.productId}
                                                    page={productPage}
                                                    setErrors={prevState => ({ ...prevState, productId: undefined })}
                                                    onClickClear={() => setInputDetail(prevState => ({ ...prevState, product: undefined }))}
                                                    onClickLoadMore={() => onClickLoadMoreProduct()}
                                                />
                                            </div>
                                            <div className='col-span-3'>
                                                <Input
                                                    label='Metre'
                                                    name="quantity"
                                                    type='number'
                                                    placeholder='Metre'
                                                    value={inputDetail.quantity}
                                                    onChange={e => onChange(e, setInputDetail)}
                                                />
                                            </div>
                                            <div className='col-span-1 mb-3 text-center justify-center flex'>
                                                <FaPlus className='cursor-pointer' onClick={onClickAddInputDetail} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='p-2 border shadow-md rounded-md mb-10'>
                                        <label className='mb-3 block'>Beklenen Ürün</label>

                                        {
                                            plan.outputDetail
                                                ?
                                                <div className='mb-2 grid grid-cols-12 gap-x-2 bg-purple-100 p-2 rounded-md'>
                                                    <div className='col-span-1'></div>
                                                    <div className='col-span-8'>
                                                        <ProductLabel state={outputDetail.product} />
                                                    </div>
                                                    <div className='col-span-2 text-center text-sm'>
                                                        {plan.outputDetail.quantity} m
                                                    </div>
                                                    <div className='col-span-1 flex justify-center self-center'>
                                                        <FaMinus className='cursor-pointer' onClick={() => onClickRemoveOutputDetail()} />
                                                    </div>
                                                </div>
                                                : <div>
                                                    <div className='grid grid-cols-12 gap-x-2 items-center'>
                                                        <div className='col-span-8'>
                                                            <ProductPicker
                                                                label='Ürün'
                                                                pendingApiCall={pendingApiCallProduct}
                                                                state={outputDetail.product}
                                                                setState={(value) => setOutputDetail(prevState => ({ ...prevState, product: value }))}
                                                                query={productQuery}
                                                                setQuery={setProductQuery}
                                                                error={errors.productId}
                                                                page={productPage}
                                                                setErrors={prevState => ({ ...prevState, productId: undefined })}
                                                                onClickClear={() => setOutputDetail(prevState => ({ ...prevState, product: undefined }))}
                                                                onClickLoadMore={() => onClickLoadMoreProduct()}
                                                            />
                                                        </div>
                                                        <div className='col-span-3'>
                                                            <Input
                                                                label='Metre'
                                                                name="quantity"
                                                                placeholder='Metre'
                                                                value={outputDetail.quantity}
                                                                onChange={e => onChange(e, setOutputDetail)}
                                                            />
                                                        </div>
                                                        <div className='col-span-1 mb-3 text-center justify-center flex'>
                                                            <FaPlus className='cursor-pointer' onClick={onClickAddOutputDetail} />
                                                        </div>
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                    <Textarea
                                        label='Açıklama'
                                        name='description'
                                        value={plan.description}
                                        onChange={e => onChange(e, setPlan)}
                                        placeholder='Açıklama girin...'
                                    />
                                    <div className="mt-4 flex justify-between">
                                        <button
                                            type="button"
                                            className="flex items-center outline-none inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200"
                                            onClick={() => setIsOpenPlanModal(false)}
                                        >
                                            İptal

                                        </button>
                                        <button
                                            type="button"
                                            className="outline-none inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 disabled:bg-blue-100"
                                            onClick={onClickAddPlan}
                                        //disabled={!variation.color && !variation.pattern && !variation.weight}
                                        >
                                            Ekle
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    )
}

export default ProductionRecordEditPage